import React from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import { GlobalErrorBoundary } from '@bingads-webui-react/global-error-boundary';
import { withGlobalErrorOptions } from './global-error-options';
import type { ErrorAction, GlobalErrorOptions } from './types';

export const withGlobalErrorView = <P extends object>(
  WrappedComponent: React.ComponentType<P>,
  errorOptions: GlobalErrorOptions | null = null,
  componentName?: string,
  errorAction?: ErrorAction
) => {
  type GlobalErrorViewProps = P & { globalErrorOptions?: GlobalErrorOptions | null };

  const GlobalErrorView = ({ globalErrorOptions = errorOptions, ...props }: GlobalErrorViewProps) => (
    <GlobalErrorBoundary
      {...globalErrorOptions}
    >
      <WrappedComponent
        {...props as P}
      />
    </GlobalErrorBoundary>
  );

  const GlobalErrorViewWithStatics = GlobalErrorView as typeof GlobalErrorView & {
    propTypes?: Record<string, unknown>;
    defaultProps?: Record<string, unknown>;
  };

  GlobalErrorViewWithStatics.propTypes = {
    globalErrorOptions: PropTypes.shape({
      logError: PropTypes.func.isRequired,
    }),
  };

  GlobalErrorViewWithStatics.defaultProps = {
    globalErrorOptions: null,
  };

  return errorOptions ? GlobalErrorView : withGlobalErrorOptions(GlobalErrorView, componentName, errorAction);
};

export const withComponentErrorLogging = _.partial(withGlobalErrorView as unknown as (...args: unknown[]) => unknown, _, null, _) as <P extends object>(
  WrappedComponent: React.ComponentType<P>,
  componentName?: string,
  errorAction?: ErrorAction,
) => React.ComponentType<P>;
